import {
  showSuccessModal,
  showErrorModal,
  showInfoModal,
  showWarningModal,
  closeFeedbackModals,
} from '@/services/rrplFeedback';

export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
  success(_, payload) {
    return showSuccessModal(payload);
  },
  error(_, payload) {
    return showErrorModal(payload);
  },
  info(_, payload) {
    return showInfoModal(payload);
  },
  warning(_, payload) {
    return showWarningModal(payload);
  },
  clear() {
    closeFeedbackModals();
  },
};
